import FlightSelection from "../../FlightSelection/FlightSelection";
import PassengerSelection from "../../PassengerSelection/PassengerSelection";
import SSROutlet from "../../../SSROutlet";
import SSRItemTotal from "../../SSRItemTotal";
import Sticky from "src/components/Sticky";

const SSRContentMob = () => {
  return (
    <>
      <div className="flex w-full flex-col gap-4 p-2">
        <div className="flex flex-col gap-6 rounded-xl">
          <Sticky
            className="gap-4"
            header={
              <div className="flex flex-col gap-4 bg-background-default py-3">
                <FlightSelection />
                <PassengerSelection />
              </div>
            }
            body={() => <SSROutlet />}
          />
        </div>
        
      </div>
      <div className="bg-background-default shadow-bottom-sheet sticky bottom-0 z-20 p-4 rounded-md">
        <SSRItemTotal />
      </div>
    </>
  );
};

export default SSRContentMob;
